import type { RunState } from "./rules";

export interface HudDetail extends RunState {
  wave: string;
  powerUp: string | null;
}

export interface ResultDetail {
  state: RunState;
  isBestScore: boolean;
  title: string;
  mode: "quick" | "campaign";
  levelId: number | null;
  levelName: string;
  comfyMode: boolean;
}

export const EVENT = {
  gameReady: "buttroids:ready",
  hud: "buttroids:hud",
  result: "buttroids:result",
  announce: "buttroids:announce",
  start: "buttroids:start",
  pause: "buttroids:pause",
  resume: "buttroids:resume",
  restart: "buttroids:restart",
  preferences: "buttroids:preferences",
} as const;

export function emit<T>(name: string, detail: T): void {
  globalThis.dispatchEvent(new CustomEvent(name, { detail }));
}
